import { useEffect, useState } from "react";
import { Button, Col, Form, Offcanvas, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { MdOutlinePostAdd } from "react-icons/md";
import { CustomInput, InputLayout, SubmitButton } from "../input";
import CustomModal from "../modal";
import FormSubmit from "../submit";

const NewAddress = ({ title, refresh, ...props }) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <div role="button" className="h-100" onClick={() => setShow(true)}>
        {title || (
          <div className="text-center h-100 list-address new-address d-flex align-items-center justify-content-center flex-column">
            <MdOutlinePostAdd className="fs-1 text-grey mb-3 mt-3" />
            <h2 className="my-3 fw-bold fs-5">New Address</h2>
          </div>
        )}
      </div>
      <Insert
        setData={(e) => refresh()}
        {...props}
        show={show}
        setShow={(e) => {
          setShow(e);
          refresh();
        }}
      />
    </>
  );
};

const Insert = ({ show, setShow, update }) => {
  const [type, setType] = useState("Home");

  return (
    <Offcanvas
      title=""
      size="md"
      placement="end"
      // className="light-modal"
      show={show}
      onHide={(_) => setShow(false)}
      close={() => setShow(false)}
    >
      <Offcanvas.Body className="mt-4 px-0">
        <FormSubmit
          url={
            "/account/address/" + (update ? "update/" + update.id : "insert")
          }
          id="addressForm"
          callback={(_) => setShow(false)}
          className="px-3"
        >
          <InputLayout>
            <Row>
              <Col>
                <CustomInput
                  defaultValue={update?.location?.zipcode}
                  name="zipcode"
                  title="Zipcode"
                  type="number"
                />
              </Col>
            </Row>
            <CustomInput
              defaultValue={update?.street}
              name="street"
              title="Street"
            />
            <Row>
              <Col sm="6">
                <CustomInput
                  defaultValue={update?.building}
                  name="building"
                  title="Appartment, House Num"
                  required={true}
                />
              </Col>
              <Col sm="6">
                <CustomInput
                  defaultValue={update?.landMark}
                  name="landmark"
                  placeholder="(optional)"
                  title="Landmarks"
                  required={false}
                />
              </Col>
            </Row>
          </InputLayout>
          <p className="font-md fw-bold text-uppercase">Contact Information</p>
          <InputLayout>
            <Row>
              <Col sm="6">
                <CustomInput
                  defaultValue={update?.name}
                  name="name"
                  title="Name"
                />
              </Col>
              <Col sm="6 mb-">
                <CustomInput
                  defaultValue={update?.mobile}
                  name="mobile"
                  title="Mobile"
                  type="number"
                />
              </Col>
              <Col sm="12 mb-">
                <CustomInput
                  defaultValue={update?.email}
                  name="email"
                  title="Email"
                  type="email"
                />
              </Col>
            </Row>
          </InputLayout>
          <Row>
            <input type="hidden" name="type" value={type} />
            {AddressType.map((x) => (
              <Col sm="auto">
                <Button
                  onClick={() => setType(x)}
                  className={`rounded-pill font-sm border shadow-none px-4`}
                  variant={type === x ? "info" : "light"}
                >
                  {x}
                </Button>
              </Col>
            ))}
          </Row>
          <SubmitButton
            title={update ? "Update Address" : "Add Address"}
            variant="dark py-2 text-white w-100 font-sm my-4"
          />
        </FormSubmit>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default NewAddress;

const AddressType = ["Home", "Office"];
